var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C6.96447 3 6.125 3.83947 6.125 4.875C6.125 5.91053 6.96447 6.75 8 6.75C9.03553 6.75 9.875 5.91053 9.875 4.875C9.875 3.83947 9.03553 3 8 3ZM4.875 4.875C4.875 3.14911 6.27411 1.75 8 1.75C9.72589 1.75 11.125 3.14911 11.125 4.875C11.125 6.60089 9.72589 8 8 8C6.27411 8 4.875 6.60089 4.875 4.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 10.5C4.46447 10.5 3.625 11.3395 3.625 12.375V14.25H2.375V12.375C2.375 10.6491 3.77411 9.25 5.5 9.25H10.5C12.2259 9.25 13.625 10.6491 13.625 12.375V14.25H12.375V12.375C12.375 11.3395 11.5355 10.5 10.5 10.5H5.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageUser);
export default __webpack_public_path__ + "static/media/messageUser.8ad345a60b524626262295a19b751af6.svg";
export { ForwardRef as ReactComponent };